import React from 'react';
import GovernEdge from '../../asset/GovernEdge.png'
import Nilaithal from '../../asset/Nilaithal.png'
import Citadel from '../../asset/Citadel.png'
import Coverton from '../../asset/Coverton.svg'
import Unicorn from '../../asset/Unicorn.png'
import Triton from '../../asset/Triton.png'
import { Button } from '../ui/button';

export const ClientsSection=() => {

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };
  
  const clients = [
    {
      name: "GovernEdge",
      logo: GovernEdge
    },
    {
      name: "Nilaithal",
      logo: Nilaithal
    },
    {
      name: "Citadel",
      logo: Citadel
    },
    {
      name: "Coverton",
      logo: Coverton
    },
    {
      name: "Unicorn",
      logo: Unicorn
    },
    {
      name: "Envato",
      logo: Triton
    },
  ];

  return (
    <section className="py-6 sm:py-8 px-4 sm:px-6 bg-white relative overflow-hidden">
      <div className="max-w-[75rem] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-center">
          {/* Left side content */}
          <div className="text-center lg:text-left">
            <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase">OUR CLIENTS</h2>
            <h3 style={{lineHeight:1.3}} className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mb-4 sm:mb-2">
              Know Who Walk's the<br/>Talk at Offis Bay
            </h3>
            
            
            <p className="mb-4 sm:mb-6 text-[#6D7E94] text-sm sm:text-base font-[500]">
              Ready Have Your Brand Hosted?
            </p>
            <div className="">
              <Button onClick={scrollToBookATour}
                style={{borderRadius:'30px'}} className="text-[15px] text-white px-8 rounded-[30px] mr-0 sm:mr-8 hover:bg-[#7d5262] transition-colors w-full sm:w-auto">                
                Yes
              </Button>
            </div>
          </div>
          
          {/* Right side logos grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {clients.map((client, index) => (
                <img 
                  key={index}
                  src={client.logo} 
                  alt={client.name} 
                  className="max-w-full object-contain"
                />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
